/**********************
 * PRELOAD
 * load jquery if it doesn't exist
 ***********************/

const JqueryUrl = "//www.bigonelectricals.co.uk/cdn/shop/t/216/assets/jquery-3.7.1.min.js?v=158417595810649192771762442337;"

if(!window.jQuery){
    var jqueryScript = document.createElement('script');
    jqueryScript.setAttribute('src', JqueryUrl);
    document.head.appendChild(jqueryScript);
}

// PRICE VAR FIX
// We use the onreadystatechange to ensure our stuff runs after everything that could break it eg. algolia is loaded.
////////////////

window.addEventListener('load', function(){
    console.log("LOADED CUSTOM JS 1");

    // SKU UPDATE ON CHANGE
    


    // VAT TOGGLE
    const vatToggleSwitch = document.getElementById("vat-toggle-switch");

    if (vatToggleSwitch) {
        vatToggleSwitch.addEventListener("change", function() {
            console.log("VAT-TOGGLEE");
            const includeVAT = vatToggleSwitch.checked;
            // You can pass any other required parameters to the function if needed
            handleVatToggle(includeVAT);
        });
    }
});

document.onreadystatechange = () => {
    if (document.readyState === "complete") {
        console.log("LOADED CUSTOM JS 2");

        // PDP
        $('.template-product .js-pdp-radio__input').on('click', function (e) {
            // console.log("CLICKED PDP");
            if (e.target.getAttribute('data-var-sku')) {
                // var $parent = $(this).closest('.product-main__price'); // Find the parent with the specified class

                var PDPVarSku = $(this).attr('data-var-sku');
                var PDPVarSkuPrice = $(this).attr('data-var-price');
                var PDPVarSkuStock = $(this).attr('data-var-stock');
                //console.log("PDP-SKU: " + PDPVarSku);
                //console.log("PDP-SKU-PRICE: " + PDPVarSkuPrice);
               // console.log("PDP-STOCK: " + PDPVarSkuStock);

                // Update the elements within the parent
                if (PDPVarSku.length > 0) $('.product-main__details .js-pdp-sku').text(PDPVarSku);
                if (PDPVarSku.length > 0) $('.product-main__details .product-price__money').text(PDPVarSkuPrice);
                $('.js-product-stock-qty').text(PDPVarSkuStock);
                if(PDPVarSkuStock < 1){
                    console.log("NO STOCK OF THIS VAR");
                    $('.stock-level__link--available').hide();
                } else {
                    $('.stock-level__link--available').show();
                }
            }
        });
        // PLP - template-collection
        $('.template-collection .js-pdp-radio__input').on('click', function (e) {
            console.log("CLICKED PLP");
            if (e.target.getAttribute('data-var-sku')) {
                var $parent = $(this).closest('.product-card-complex__right'); // Find the parent with the specified class

                var PDPVarSku = $(this).attr('data-var-sku');
                var PDPVarSkuPrice = $(this).attr('data-var-price');
                var PDPVarSkuStock = $(this).attr('data-var-stock');
                //console.log("PDP-SKU: " + PDPVarSku);
                //console.log("PDP-SKU-PRICE: " + PDPVarSkuPrice);
                //console.log("PDP-STOCK: " + PDPVarSkuStock);

                // Update the elements within the parent
                // if (PDPVarSku.length > 0) $('.product-main__details .js-pdp-sku').text(PDPVarSku);
                // if (PDPVarSku.length > 0) $('.product-main__details .product-price__money').text(PDPVarSkuPrice);

                if (PDPVarSku.length > 0) $parent.find('.js-pdp-sku').text(PDPVarSku);
                if (PDPVarSku.length > 0) $parent.find('.product-price__money').text(PDPVarSkuPrice);
                if (PDPVarSkuStock.length > 0) $parent.find('.js-product-stock-qty').text(PDPVarSkuStock);
                if(PDPVarSkuStock < 1){
                    console.log("NO STOCK OF THIS VAR");
                    $('.stock-level__link--available').hide();
                } else {
                    $('.stock-level__link--available').show();
                }
            }
        });
    }
};


// NEW VAT TOGGLE HANDLER

function handleVatToggle(includeVAT, card) {
    console.log("VAT-TOGGLE");
    const format = document.body.getAttribute('data-money-format') || '';

    // Find the parent element of the variant selector
    const variantSelectorParent = card ? card.closest('.product-card-complex__right') : null;

    let moneys = document.querySelectorAll('[data-money]');

    if (variantSelectorParent) {
        moneys = variantSelectorParent.querySelectorAll('[data-money]');
    }

    if (includeVAT) {
        localStorage.setItem('vat_status', 'true');

        moneys.forEach(function(money) {
            const pennies = Number(money.getAttribute('data-money') || 0);
            const cost = (pennies / 100).toFixed(2);
            money.textContent = format.replace('', cost.toString());

            const productPrice = money.closest('.product-price');
            if (productPrice) {
                productPrice.classList.add('product-price--vat');
            }
        });
    } else {
        localStorage.setItem('vat_status', 'false');

        moneys.forEach(function(money) {
            const pennies = Number(money.getAttribute('data-money') || 0);
            const cost = (pennies / 1.2 / 100).toFixed(2);
            money.textContent = format.replace('', cost.toString());

            const productPrice = money.closest('.product-price');
            if (productPrice) {
                productPrice.classList.remove('product-price--vat');
            }
        });
    }
}


// CART SLIDE UP BUTTON
/////////////////////////
const elementToSlide = document.querySelector('.js-sticky-atc');
const viewportIndicator = document.querySelector('.js-main-pdp-product-form-button');
// Check if the element has scrolled past the top of the viewport

function isElementAboveViewport(element) {
    if(element){
        const elementRect = element.getBoundingClientRect();
        return elementRect.bottom <= 0;
    }
}
// Handle the slide effect
function handleSlideEffect() {
    if (isElementAboveViewport(viewportIndicator)) {
        elementToSlide.style.bottom = '0';
    } else {
        elementToSlide.style.bottom = '-100%';
    }
}

// Initial check and event listener for scroll
if(elementToSlide){
    handleSlideEffect();
    window.addEventListener('scroll', handleSlideEffect);
}

// CART HEADER FIX
//////////////////
const headerElement = document.querySelector('.site-header');
const bodyElement = document.querySelector('body');
// Function to be called when the "side-cart--active" class is added
function cartOpenClassAddedCallback(mutationsList, observer) {
    for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const targetElement = mutation.target;
            const classList = targetElement.classList;

            // Check if the "side-cart--active" class exists
            if (classList.contains('side-cart--active')) {
                // Remove Classes
                headerElement.classList.remove('site-header--down');
                bodyElement.classList.remove('site-header--down');
                // Add new ones
                headerElement.classList.add('site-header--up');
                bodyElement.classList.add('site-header--up');
            }
        }
    }
}
// Options for the MutationObserver (configuring what to observe)
const observerConfig = {
    attributes: true, // Watch for changes to attributes (including class)
    attributeFilter: ['class'], // Watch for changes specifically to the "class" attribute
    subtree: true // Watch for changes in the entire subtree of the target
};
// Select the target element to observe
const targetElement = document.body; // You can choose any other element as your target
// Create a new MutationObserver with the callback function and options
const observer = new MutationObserver(cartOpenClassAddedCallback);
// Start observing the target element
observer.observe(targetElement, observerConfig);

// PRODUCT SPECS BUTTON
///////////////////////
// Wait for the DOM to fully load
document.addEventListener('DOMContentLoaded', function() {
    // Get all elements with the class 'js-product-info-btn'
    var infoButtons = document.querySelectorAll('.js-product-info-btn');

    // Function to get the offset height of the header
    function getHeaderOffset() {
        var header = document.querySelector('site-header');
        return header ? header.offsetHeight : 0;
    }

    // Loop through each button and add a click event listener
    infoButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            // Get the element with the class 'js-product-specs'
            var specsElement = document.querySelector('.js-product-specs');

            // If the element exists, add the 'open' attribute to it and scroll to it with offset
            if (specsElement) {
                specsElement.setAttribute('open', '');

                // Calculate the scroll position with the offset
                var headerOffset = getHeaderOffset();
                var elementPosition = specsElement.getBoundingClientRect().top;
                var offsetPosition = elementPosition + window.pageYOffset - headerOffset - 64;

                // Scroll to the element with smooth behavior
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
});